export default "__VITE_PUBLIC_ASSET__3feba58b__"